import { useDispatch } from "react-redux";

import { EditIcon, LayerIcon, TrashIcon } from "@/assets/icons";
import { useMap } from "@/hooks/map/core/useMapContext";
import { useConfirmationModal } from "@/hooks/ui/modal/useConfirmationModal";
import { enableDrawPolygon } from "@/store/slice/uiSlice";
import { PolygonSettingItem } from "@/types/spatial";

interface PolygonItemProps {
  polygon: PolygonSettingItem;
}

export default function PolygonItem(props: Readonly<PolygonItemProps>) {
  const { polygon } = props;

  const dispatch = useDispatch();
  const { deleteFeature, enterEditMode } = useMap();
  const { showConfirmation } = useConfirmationModal();

  const handleDelete = () => {
    showConfirmation({
      title: "Delete This Custom Polygon?",
      message: (
        <p className="text-center">
          Deleting this will permanently remove the polygon settings. This
          action can't be undone.
        </p>
      ),
      confirmLabel: "Delete",
      cancelLabel: "Cancel",
      onConfirm: () => deleteFeature(polygon.id)
    });
  };

  const handleEdit = () => {
    dispatch(enableDrawPolygon());
    enterEditMode(polygon.id);
  };

  return (
    <div className="flex flex-row group items-center p-2.5 rounded-lg border border-gainsboro bg-white">
      <div className="flex items-center justify-center p-0.5 group-hover:bg-teal-50 mr-2.5 rounded-[0.25rem]">
        <LayerIcon
          className="fill-dim-gray group-hover:fill-primary-teal"
          width={16}
          height={16}
        />
      </div>

      <p className="text-xs text-txtHeading group-hover:text-primary-teal">
        {polygon.name}
      </p>

      <div className="flex gap-1 items-center ml-auto">
        <button
          className="!w-4 !h-4 !p-0"
          type="button"
          aria-label={`Edit polygon ${polygon.name}`}
          onClick={handleEdit}
        >
          <EditIcon />
        </button>
        <button
          className="!w-4 !h-4 !p-0"
          type="button"
          aria-label={`Delete polygon ${polygon.name}`}
          onClick={handleDelete}
        >
          <TrashIcon className="fill-txtBody" />
        </button>
      </div>
    </div>
  );
}
